///adapted from https://github.com/damiisdandy/use-pagination
import { UsePagination } from '../interfaces/Common';
import { useMemo, useState } from 'react';
import { SortObject } from '../interfaces/Common';

export const getTableColumnWidth = (tableColumnConfig: Array<any>) => {
    let cWidthConfigArr: string = '{';
    tableColumnConfig.map((c: any,i: number) => {
        cWidthConfigArr = cWidthConfigArr + "'" + c.key + "' : '" + c.width + "'";
        if(i !== tableColumnConfig.length - 1) {
            cWidthConfigArr  = cWidthConfigArr  + ",";
        } else {
            cWidthConfigArr  = cWidthConfigArr  + '}';
        }
        return null;
    })
    return cWidthConfigArr;
}

export const usePagination: UsePagination = ({ contentPerPage, count }: any) => {
    const [page, setPage] = useState(1);
    // number of pages in total (total items / content on each page)
    const pageCount = Math.ceil(count / contentPerPage);
    // index of last item of current page
    const lastContentIndex = page * contentPerPage;
    // index of first item of current page
    const firstContentIndex = lastContentIndex - contentPerPage;

    const setPageSAFE = (num: number) => {
        // if number is greater than number of pages, set to last page
        if (num > pageCount) {
            setPage(pageCount);
            // if number is less than 1, set page to first page
        } else if (num < 1) {
            setPage(1);
        } else {
            setPage(num);
        }
    };

    return {
        totalPages: pageCount,
        setPage: setPageSAFE,
        firstContentIndex,
        lastContentIndex,
        page
    };
};

export const useSort = (
    itemsToSort: any,
    config: any
) => {
    const [sortConfig, setSortConfig] = useState<SortObject>(config);
    const sortedList = useMemo(() => {
        const sortedFacilities = [...itemsToSort];
        if (sortConfig !== null) {
            sortedFacilities.sort((a, b) => {
                if (
                    a[sortConfig.key as keyof any] <
                    b[sortConfig.key as keyof any]
                ) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (
                    a[sortConfig.key as keyof any] >
                    b[sortConfig.key as keyof any]
                ) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortedFacilities;
    }, [sortConfig, itemsToSort]);

    const requestSort = (event: any, key: string) => {
        const direction = event.detail.direction;
        setSortConfig({ key, direction });
    };

    return { sortedList, requestSort, sortConfig };
};
